export default __webpack_public_path__ + "static/media/Background_00228.bc796e98.png";